async function fetchShopifyProduct(productId) {
  const query = `
    query {
      product(id: "gid://shopify/Product/${productId}") {
        title
        descriptionHtml
        images(first: 1) {
          edges {
            node {
              originalSrc
              altText
            }
          }
        }
        variants(first: 1) {
          edges {
            node {
              priceV2 {
                amount
              }
            }
          }
        }
      }
    }
  `;

  const SHOPIFY_API_URL = ["https://58ef7a.myshopify.com/api/2024-10/graphql.json"].join("");
  const SHOPIFY_ACCESS_TOKEN = ["07ed1", "4948", "8870", "de32", "40f6", "81d1", "ab2e", "6c"].join("");

  try {
    const response = await fetch(SHOPIFY_API_URL, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Shopify-Storefront-Access-Token": SHOPIFY_ACCESS_TOKEN
      },
      body: JSON.stringify({ query })
    });

    if (!response.ok) throw new Error("Erreur dans la rÃ©cupÃ©ration du produit");

    const result = await response.json();
    if (result.errors) {
      throw new Error("Erreur dans la rÃ©ponse de l'API Shopify : " + JSON.stringify(result.errors));
    }
    return result.data.product;
  } catch (error) {
    console.error("Erreur lors de l'appel Ã  l'API Shopify:", error);
    return null;
  }
}

const PRODUCTS = [
  { id: 'matchabrenda', pid: '16204162892111', handle: 'matcha-brenda' },
  { id: 'lafontainedejouvence', pid: '8734305091919', handle: 'la-fontaine-de-jouvence' },
  { id: 'fusion', pid: '8734295032143', handle: 'fusion' },
  { id: 'orangeboost', pid: '8734279074127', handle: 'orange-boost' },
  { id: 'supergreen', pid: '16192306348367', handle: 'super-green' },
  { id: 'podium', pid: '16192136216911', handle: 'podium' },
  { id: 'worldchampion', pid: '8734323016015', handle: 'world-champion' },
  { id: 'daylight', pid: '8734309581135', handle: 'daylight' },
  { id: 'coupdepush', pid: '8734284906831', handle: 'coup-de-push' },
  { id: 'vistaf', pid: '15364839309647', handle: 'vista-f' },
  { id: 'vistav', pid: '15364839833935', handle: 'vista-v' },
  { id: 'calicef', pid: '8734301389135', handle: 'calice-f' },
  { id: 'calicev', pid: '8734302372175', handle: 'calice-v' },
  { id: 'acaisupa', pid: '8734291329359', handle: 'acai-supa' },
  { id: 'bluezone', pid: '8734302863695', handle: 'blue-zone' }
];

function setElementFromStaticHtml(el, keepStaticIfFetchFails = true, product) {
  if (!el) return;
  if (product) {
    const title = product.title || '';
    const price = product.variants?.edges?.[0]?.node?.priceV2?.amount || '';
    const imageNode = product.images?.edges?.[0]?.node;
    const imageUrl = imageNode?.originalSrc || '';
    const imageAlt = imageNode?.altText || title || '';
    const originalHref = el.querySelector('a')?.href || '#';

    el.innerHTML = `
      <h2>${title}</h2>
      <p>Prix: ${price ? price + ' â‚¬' : 'â€”'}</p>
      <a href="${originalHref}" target="_blank">Ajouter au panier</a>
    `;

    if (imageUrl) {
      const img = document.createElement('img');
      img.src = imageUrl;
      img.alt = imageAlt;
      img.style.width = '200px';
      const h2 = el.querySelector('h2');
      if (h2 && h2.parentNode) h2.insertAdjacentElement('afterend', img);
      else el.insertBefore(img, el.firstChild);
    }
    el.style.display = 'block';
  } else if (keepStaticIfFetchFails) {
    el.style.display = 'block';
  } else {
    el.style.display = 'none';
  }
}

function toggleStaticProducts(productFlags) {
  const productsSection = document.getElementById('products');
  if (productsSection) {
    productsSection.classList.remove('hidden');
    productsSection.style.display = 'block';
  }

  Object.entries(productFlags).forEach(([elemId, shouldShow]) => {
    const el = document.getElementById(elemId);
    if (el) el.style.display = shouldShow ? 'block' : 'none';
  });
}

async function checkCriteria(fromValidation = false) {
  const selectedValues = [];

  document.querySelectorAll('#profil input[type=radio]:checked, #profil input[type=checkbox]:checked')
    .forEach(i => selectedValues.push(i.value));
  document.querySelectorAll('#moments input[type=radio]:checked')
    .forEach(i => selectedValues.push(i.value));

  // MODIFICATION : plusieurs besoins peuvent Ãªtre cochÃ©s et dÃ©cochÃ©s.
  document.querySelectorAll('#besoins input[type=checkbox]:checked')
    .forEach(i => selectedValues.push(i.value));

  document.querySelectorAll('#envies1 input[type=checkbox]:checked')
    .forEach(i => selectedValues.push(i.value));

  const condition1 = selectedValues.includes("Hommes") || selectedValues.includes("Femmes");
  const condition2 = selectedValues.includes("Enfants") || selectedValues.includes("Ados") || selectedValues.includes("Adultes");
  const condition3 = selectedValues.some(v => ["Ecole", "Etudes", "Travail", "Detente", "Sport"].includes(v));
  const condition4 = selectedValues.some(v => ["Sansregime", "Flexitarien", "Pesco", "Lactose", "Vegetarien", "Soja", "Gluten"].includes(v));
  const condition5 = selectedValues.some(v => ["Lactose", "Soja", "Gluten"].includes(v));
  const condition6 = selectedValues.some(v => ["Sansregime", "Flexitarien", "Pesco", "Vegetarien", "Soja", "Gluten"].includes(v));
  const condition7 = selectedValues.some(v => ["Sansregime", "Flexitarien", "Pesco", "Lactose", "Vegetarien", "Soja"].includes(v));
  const condition8 = selectedValues.some(v => ["Sansregime", "Flexitarien", "Pesco", "Vegetarien", "Soja"].includes(v));
  const condition9 = selectedValues.includes("Pdejeuner") || selectedValues.includes("Pfaim") || selectedValues.includes("Dejeuner") || selectedValues.includes("Gouter") || selectedValues.includes("Before");
  const condition10 = selectedValues.includes("Pfaim") || selectedValues.includes("Dejeuner") || selectedValues.includes("Before");
  const condition11 = selectedValues.includes("Energie");
  const condition12 = selectedValues.includes("Energie") || selectedValues.includes("Defenses");
  const condition13 = selectedValues.includes("Energie") || selectedValues.includes("Humeurandintellect");
  const condition14 = selectedValues.includes("Energie") || selectedValues.includes("GLL");
  const condition15 = selectedValues.includes("Energie") || selectedValues.includes("Beaute");
  const condition16 = selectedValues.includes("GLL");
  const condition17 = selectedValues.includes("Beaute");
  const condition18 = selectedValues.includes("Beaute") || selectedValues.includes("Defenses");
  const condition19 = selectedValues.includes("Defenses");
  const condition20 = selectedValues.includes("Humeurandintellect");
  const condition21 = selectedValues.includes("CandR");
  const condition22 = selectedValues.includes("Jus");
  const condition23 = selectedValues.includes("Smoothies");
  const condition24 = selectedValues.includes("Salades");
  const condition25 = selectedValues.includes("Bowlsandtoasts");
  const condition26 = selectedValues.includes("GLL") || selectedValues.includes("Beaute");
  const condition27 = selectedValues.some(v => ["Ecole", "Etudes", "Travail", "Detente"].includes(v));

  const productFlags = {
    matchabrenda: condition1 && condition2 && condition3 && condition4 && condition9 && condition26 && condition22,
    lafontainedejouvence: condition1 && condition2 && condition3 && condition4 && condition9 && condition17 && condition22,
    fusion: condition1 && condition2 && condition3 && condition4 && condition9 && condition14 && condition22,
    orangeboost: condition1 && condition2 && condition3 && condition4 && condition9 && condition11 && condition22,
    supergreen: condition1 && condition2 && condition3 && condition4 && condition9 && condition16 && condition23,
    podium: condition1 && condition2 && condition3 && condition4 && condition9 && condition11 && condition23,
    worldchampion: condition1 && condition2 && condition3 && condition4 && condition9 && condition21 && condition23,
    daylight: condition1 && condition2 && condition3 && condition4 && condition9 && condition18 && condition23,
    coupdepush: condition1 && condition2 && condition3 && condition4 && condition9 && condition11 && condition23,
    vistaf: condition1 && condition2 && condition3 && condition5 && condition9 && condition17 && condition24,
    vistav: condition1 && condition2 && condition3 && condition4 && condition9 && condition17 && condition24,
    calicef: condition1 && condition2 && condition3 && condition5 && condition9 && condition16 && condition24,
    calicev: condition1 && condition2 && condition3 && condition4 && condition9 && condition16 && condition24,
    acaisupa: condition1 && condition2 && condition3 && condition4 && condition9 && condition11 && condition25,
    bluezone: condition1 && condition2 && condition3 && condition4 && condition9 && condition16 && condition25
  };

  if (fromValidation) {
    toggleStaticProducts(productFlags);
    for (const p of PRODUCTS) {
      if (!productFlags[p.id]) continue;
      const el = document.getElementById(p.id);
      if (!el) continue;
      try {
        const product = await fetchShopifyProduct(p.pid);
        if (product) {
          setElementFromStaticHtml(el, true, product);
          const anchor = el.querySelector('a');
          if (anchor) anchor.href = `https://viitale.fr/products/${p.handle}`;
        } else {
          el.style.display = 'block';
        }
      } catch (err) {
        console.error('Erreur lors du rendu dynamique du produit', p.id, err);
        el.style.display = 'block';
      }
    }
  }

  return productFlags;
}

document.addEventListener('DOMContentLoaded', () => {
  const inputs = document.querySelectorAll('#profil input, #moments input, #besoins input, #envies1 input');
  inputs.forEach(i => i.addEventListener('change', () => checkCriteria(false).catch(console.error)));

  const validerBtn = document.getElementById('valider3');
  if (validerBtn) {
    validerBtn.addEventListener('click', (e) => {
      if (e && typeof e.preventDefault === 'function') e.preventDefault();
      checkCriteria(true).catch(err => console.error('Erreur checkCriteria:', err));
    });
  }
});